import { post } from "@insite/client-framework/Services/ApiService";
import { TellAFriendApiParameter } from "@insite/client-framework/Services/EmailService";
import { TellAFriendModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrl = "/api/v2/email";

export function tellAFriendV2(parameter: TellAFriendApiParameter) {
    return post<TellAFriendModel>(`${emailsUrl}/tellafriend`, parameter.tellAFriendModel);
}
